import { mutationFor } from "@visioni/a3s-client-api/app";
import { triggerTestSignalEndpoint } from "../client-messages/test-signals";

export const triggerTestSignalMutation = mutationFor(triggerTestSignalEndpoint);
